import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import chain1 from "../assets/product/chain1.png";
import chain2 from "../assets/product/chain2.png";
import chain3 from "../assets/product/chain3.png";
import chain4 from "../assets/product/chain4.png";
import chain5 from "../assets/product/chain5.png";
import chain6 from "../assets/product/chain6.png";
import chain7 from "../assets/product/chain7.png";
import chain8 from "../assets/product/chain8.png";
import chain9 from "../assets/product/chain9.png";
import chain10 from "../assets/product/chain1.png";
import ringImg1 from "../assets/ring-img-1.png";
import ringImg2 from "../assets/ring-img-2.png";
import ringImg3 from "../assets/ring-img-3.png";
import CategoriesService from '../services/API/CategoriesService';
import { BASE_URL } from '../services/Constant'
import CmsService from '../services/API/CmsService';

const Main2 = () => {
    const [products, setProducts] = useState([]);
    const [earingProductsId, setEaringProductsId] = useState([]);
    const [chainProductsId, setChainProductsId] = useState([]);
    
  const [productsContent, setProductsContent] = useState([]);
  const [productsEar, setProductsEar] = useState([]);
  const [productsEarContent, setProductsEarContent] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
console.log('products',products);

    const fetchCategoryData = async () => {
        try {
          const res = await CategoriesService.getCategoryData();
          if (res.status) {
            const earringsCategory = res.data.find(category => category.name === "Popular Chain");
            if (earringsCategory) {
              setChainProductsId(earringsCategory);
              console.log('earringsCategoryrrr',earringsCategory);
              setProducts(earringsCategory.products);
              setProductsContent(earringsCategory);
            }
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
      };

      const fetchCategoryDataEar = async () => {
        try {
          const res = await CategoriesService.getCategoryData();
          if (res.status) {
            const earringsCategory = res.data.find(category => category.name === "Earrings");
            console.log('earringsCategory', earringsCategory);
            setEaringProductsId(earringsCategory);
            
            if (earringsCategory) {
              setProductsEar(earringsCategory.products);
              setProductsEarContent(earringsCategory);
            }
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
      };
      const [data, setData] = useState([]);
    
      const fetchCenterBanner = async () => {
        try {
          const res = await CmsService.centerSection();
            const response = res.data[0];
            setData(response)
              console.log('bannerCenter',response);
              // console.log('banner',data);
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
      };
      const [dataBottom, setDataBottom] = useState([]);

  const fetchBottomBanner = async () => {
    try {
      const res = await CmsService.bottomSection();
        const response = res.data[0];
        setDataBottom(response)
          console.log('banner',response);
          // console.log('banner',data);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };
      useEffect(() => {
        fetchBottomBanner();
        fetchCenterBanner();
        fetchCategoryDataEar();
        fetchCategoryData();
      }, []);
    return (
        <>
            <div className='home-page-sec2-bg-banner' style={{backgroundImage: `url(${data.homeCenterImage})`}}>
                <Container >
                    <div className='home-page-sec2-text-div '>
                        <h1 className='home-page-sec2-text'>{data.title}</h1>
                        <div className='home-page-sec2-btn-div'>
                            <button className='home-page-sec2-btn'>Buy Now</button>
                        </div>
                    </div>
                </Container>
            </div>

            <div className='container'>
                <div className='home-page-sec-div'>
                    <h2 className='home-page-sec-text'>POPULAR CHAIN</h2>
                    <div className='home-page-sec-btn-div-va'>
                        <Link to={`/category/${chainProductsId.id}`} >
                            <button className='home-page-sec-btn-va'>View All</button>
                        </Link>
                    </div>
                    <div className='home-page-sec3-main-div'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 text-left'>
                    {isLoading ? (
                  <div>Loading...</div>
                ) : (
                  products.map((product, index) => (
                     <Link key={index} to={`product/${product.id}`} className='block bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition transform hover:-translate-y-1'>
                                 <div className='relative h-48 w-full overflow-hidden rounded-lg'>
                                          <img
                                            src={`${BASE_URL}${product.image}`} alt={product.name}
                                            className='w-full h-full object-contain mx-auto'
                                          />
                                        </div>
                                  <h4 className='mt-4 text-base font-semibold text-gray-800'>{product.name.split(" ").slice(0, 4).join(" ")}{product.name.split(" ").length > 4 ? "..." : ""}</h4>
                                  <span className='text-gray-600 text-md font-bold'>${product.price}</span>
                                </Link>
                                 ))
                                )}
                        </div>
                    </div>
                </div>

                <div className='home-page-sec-div'>
                    <h2 className='home-page-sec-text'>EARRING</h2>
                    <div className='home-page-sec-btn-div-va'>
                        <Link to={`/category/${earingProductsId.id}`}>
                            <button className='home-page-sec-btn-va'>View All</button>
                        </Link>
                    </div>
                    <div className='home-page-sec3-main-div'>
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 text-left'>
                    {isLoading ? (
                  <div>Loading...</div>
                ) : (
                  productsEar.map((product, index) => (
                    <Link key={index} to={`product/${product.id}`} className='block bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition transform hover:-translate-y-1'>
                   <div className='relative h-48 w-full overflow-hidden rounded-lg'>
                                          <img
                                            src={`${BASE_URL}${product.image}`} alt={product.name}
                                            className='w-full h-full object-contain mx-auto'
                                          />
                                        </div>
                    <h4 className='mt-4 text-base font-semibold text-gray-800'>{product.name.split(" ").slice(0, 4).join(" ")}{product.name.split(" ").length > 4 ? "..." : ""}</h4>
                    <span className='text-gray-600 text-md font-bold'>${product.price}</span>
                  </Link>
                                 ))
                                )}
                        </div>
                    </div>
                </div>

                <div className='home-page-sec5-main-div'>
                    <div className='row'>
                        <div className='col-lg-8'>
                            <div className='home-page-sec5-img-div'>
                                <img src={dataBottom.firstImage} alt='ring image' />
                                <div className='home-page-sec5-img-btn-div' >
                                    <h3>{dataBottom.title}</h3>
                                    <button>Explore</button>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4' style={{display: "flex", alignItems: "center"}}>
                            {/* <div className='home-page-sec5-div-2'> */}
                            <div className='row' style={{alignItems: "center", gap: "25px 0"}}>
                                <div className='col-lg-12 col-6'>
                                    <div className='home-page-sec5-img-div'>
                                        <img src={dataBottom.secoundImage} alt='ring image' />
                                    </div>

                                </div>
                                <div className='col-lg-12 col-6'>

                                    <div className='home-page-sec5-img-div'>
                                        <img src={dataBottom.newThirdImage} alt='ring image' />
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Main2